/* istanbul ignore file */
/**
 * Light color scheme configuration for NgKit theme.
 * Defines surface colors, form fields, text, content, overlay, and navigation styles.
 */

export const lightColorScheme = {
  light: {
    surface: {
      0: '#ffffff',
      25: '#f8f9fb',
      50: '#f2f3f4',
      100: '#e7e8e9',
      150: '#d9dbdc',
      200: '#cacbcd',
      250: '#bebfc1',
      300: '#adafb1',
      350: '#9e9fa2',
      400: '#8f9194',
      450: '#828487',
      500: '#757779',
      550: '#686a6d',
      600: '#5c5d5f',
      650: '#505153',
      700: '#414244',
      750: '#363739',
      800: '#2a2a2b',
      850: '#212122',
      900: '#171718',
      950: '#0c0c0d',
      1000: '#222222',
    },
    primary: {
      color: '{primary.600}',
      contrastColor: '#ffffff',
      hoverColor: '{primary.800}',
      activeColor: '{primary.800}',
    },
    highlight: {
      background: '{surface.100}',
      focusBackground: '{surface.150}',
      color: '{surface.950}',
      focusColor: '{surface.950}',
    },
    mask: {
      background: '{transparentblack.120}',
      color: '{surface.200}',
    },
    formField: {
      background: '{surface.0}',
      disabledBackground: '{surface.0}',
      filledBackground: '{infinity.100}',
      filledHoverBackground: '{fireworks.100}',
      filledFocusBackground: '{coralreef.100}',
      borderColor: '{surface.600}',
      hoverBorderColor: '{primary.color}',
      focusBorderColor: '{primary.color}',
      invalidBorderColor: '{error.500}',
      color: '{surface.900}',
      disabledColor: '{surface.200}',
      placeholderColor: '{surface.400}',
      invalidPlaceholderColor: '{error.550}',
      floatLabelColor: '{surface.800}',
      floatLabelFocusColor: '{surface.800}',
      floatLabelActiveColor: '{surface.800}',
      floatLabelInvalidColor: '{surface.800}',
      iconColor: '{surface.800}',
      shadow: 'none',
    },
    text: {
      color: '{surface.1000}',
      hoverColor: '{surface.1000}',
      mutedColor: '{surface.600}',
      hoverMutedColor: '{surface.600}',
    },
    content: {
      background: '{surface.0}',
      hoverBackground: '{surface.100}',
      borderColor: '{greymatter.100}',
      color: '{surface.950}',
      hoverColor: '{text.hover.color}',
    },
    overlay: {
      select: {
        background: '{surface.0}',
        borderColor: 'transparent',
        color: '{text.color}',
      },
      popover: {
        background: '{surface.0}',
        borderColor: 'transparent',
        color: '{text.color}',
      },
      modal: {
        background: '{surface.0}',
        borderColor: 'transparent',
        color: '{text.color}',
      },
    },
    list: {
      option: {
        focusBackground: '{surface.200}',
        selectedBackground: '{highlight.background}',
        selectedFocusBackground: '{highlight.focusBackground}',
        color: '{text.color}',
        focusColor: '{text.hover.color}',
        selectedColor: '{highlight.color}',
        selectedFocusColor: '{highlight.focusColor}',
        icon: {
          color: '{surface.800}',
          focusColor: '{text.hover.muted.color}',
        },
      },
      optionGroup: {
        background: 'transparent',
        color: '{text.color}',
      },
    },
    navigation: {
      item: {
        focusBackground: '{primary.color}',
        activeBackground: '{surface.200}',
        color: '{text.color}',
        focusColor: '{primary.contrastColor}',
        activeColor: '{text.hover.color}',
        icon: {
          color: '{text.muted.color}',
          focusColor: '{primary.contrast.color}',
          activeColor: '{text.hover.muted.color}',
        },
      },
      submenuLabel: {
        background: 'transparent',
        color: '{text.muted.color}',
      },
      submenuIcon: {
        color: '{surface.800}',
        focusColor: '{primary.contrastColor}',
        activeColor: '{text.hover.muted.color}',
      },
    },
  },
};
